//VENDOR START
import 'babel-polyfill';
import 'jquery';
import 'jquery-ui';
import 'typeahead.js/dist/typeahead.jquery';
import 'typeahead.js/dist/bloodhound';
import 'slick-carousel';
import 'bootstrap-sass/assets/javascripts/bootstrap.js';
import 'bootstrap-select';
import 'angular';
import 'angular-sanitize';
import 'angular-animate';
import 'angucomplete-alt';
import 'ng-infinite-scroll';
import 'ng-combo-date-picker';
import 'ng-debounce/dist/ng-debounce.js';
import 'ngstorage';
import 'angularjs-facebook';
import 'angular-formly';
import 'angular-formly-templates-bootstrap';
import 'angular-toastr';
import 'angular-ui-bootstrap';
import 'angular-no-captcha';
import 'angular-swipe';
import 'moment';
import 'platform-gaecommercetracking';
import 'angular-recaptcha';
import 'angular-cookies'

//VENDOR END

//VENDOR CSS START
require('font-awesome/css/font-awesome.css');
require('angular-toastr/dist/angular-toastr.css');

//VENDOR CSS END

//CSS START
require('../sass/main.scss');

//CSS END


//JS START
import './app/app';
import './scripts';
import './app/config/environment.config';
import './app/config/formly.config';
import './app/config/app.run';
import './app/config/facebook.config';
import './app/config/nocaptcha.config';
import './app/config/toastr.config';
import './app/config/google.analytics.config.js';
import './app/filters/split.camel.case.filter';
import './app/services/items.service';
import './app/services/loader.service';
import './app/services/customer.service';
import './app/services/cart.service';
import './app/services/errors.service';
import './app/services/api.service';
import './app/services/formlyfields.service';
import './app/services/order.service'
import './app/services/ga.product.service';
import './app/services/localstorage.service';
import './app/components/alphanumericvalidation.directive';
import './app/components/product-image.component';
import './app/components/initselectpicker.directive';
import './app/components/phonevalidation.directive';
import './app/components/loader.component';
import './app/components/carousel.component';
import './app/order/order.controller';
import './app/order/order.list.controller';
import './app/order/order.details.controller';
import './app/search/search.controller';
import './app/services/payment-fields.service';
import './app/cart/cart.controller';
import './app/cart/cart.payment.controller';
import './app/cart/cart.payment.model.controller';
import './app/cart/cart.items.controller';
import './app/cart/cart.preview.controller';
import './app/messages/messages.controller';
import './app/messages/messages.modal.controller';
import './app/customer/customer.controller';
import './app/products/product-detail.controller';
import './app/products/productlist.controller';
import './app/components/addtocart.directive';
import './app/customer/customer.login.controller';
import './app/customer/customer.resetpassword';
import './app/customer/customer.forgotpassword.controller';
import './app/customer/customer.registration';
import './app/services/messages.service';
import './app/contact/contact.controller';
import './app/search/search-form.controller';
import './app/components/privacy-policy-popup.component';

//JS END



// WEBPACK FOOTER //
// ./static/js/main.js